import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=218c106c"
import script from "./verifyCode.vue?vue&type=script&lang=js"
export * from "./verifyCode.vue?vue&type=script&lang=js"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=218c106c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/kft.ycxxkj.com/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218c106c')) {
      api.createRecord('218c106c', component.options)
    } else {
      api.reload('218c106c', component.options)
    }
    module.hot.accept("./verifyCode.vue?vue&type=template&id=218c106c", function () {
      api.rerender('218c106c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/verifyCode.vue"
export default component.exports